import { HStack, Text } from '@chakra-ui/react';

import { IconProps, IconsLinear } from '@nocowanie/icons';

import { GuestsPictogramsProps } from './guests-pictograms.props';

const renderPictograms = (count: number, IconComponent: (props: IconProps) => JSX.Element) => (
    <>
        {count > 2 ? (
            <>
                <IconComponent size={'md'} css={{ '--icon-stroke': 1 }} />
                <Text as={'span'} fontSize={{ base: 'xs', md: 'sm' }} lineHeight={'1'} mr={2}>
                    {count}x
                </Text>
            </>
        ) : (
            Array.from({ length: count }, (_, index) => (
                <IconComponent key={index} size={'md'} css={{ '--icon-stroke': 1 }} />
            ))
        )}
    </>
);

export const GuestsPictograms = ({
    adultsCount,
    childrenCount,
    ...props
}: GuestsPictogramsProps) => {
    return (
        <HStack align={'center'} gap={0} {...props}>
            {renderPictograms(adultsCount, IconsLinear.People)}
            {childrenCount ? <>+ {renderPictograms(childrenCount, IconsLinear.Kids)}</> : null}
        </HStack>
    );
};
